module.exports = __webpack_public_path__ + "static/media/illo_idea.6d11368e.svg";